import React, { useState } from 'react'
import { showToast } from '../../../../CBP_App/util/showToast'
import { getHistoryDocuments, getSignedUrls } from '../../../../apiCalls/MainFormRequests'
import { historyMockData } from './data'

export default function useHistory() {
    const [history, setHistory] = useState([])
    const [loading, setLoading] = useState(false)

    const getHistory = async () => {
        try {
            setLoading(true)
            const response = await getHistoryDocuments(window.shipmentId)
            if (response) {
                setHistory(response?.data?.eventMessage?.cbpDisHistory || [])
            }
        } catch (error) {
            showToast('Failed to load history. Please try again.')
        }
        finally {
            setLoading(false)
        }
    }
    const handleSeeDocument = async (fileName) => {
        try {
            let bucket =  window._env_?.KN_US_DIS_GATEWAY_BUCKET || ""
            const res = await getSignedUrls({ bucket, files: [fileName] })
            const url = res?.data?.eventMessage?.urls?.[0]
            if (url) {
                window.open(url, '_blank')
            }
        } catch (error) {
            showToast('Failed to fetch document. Please try again.')
        }
    }
    return { getHistory, history,  loading, handleSeeDocument }
}
